import {
  Box,
  Breadcrumb,
  type BreadcrumbItems,
  Typography
} from "@dealer-center/core-components";
import { Locale } from "@dealer-center/ddc-core-utils";
import { SPACE_BLOCK } from "../../layoutTokens";

/**
 * FR-003's breadcrumb and page heading.
 *
 * Split out of `IdentityHeader` when the card frame landed, because the two sit on opposite sides of
 * the card's edge: the trail and the `h1` are page furniture on the app background, while the
 * identity row is the card's first row. One component spanning that boundary could not be placed.
 *
 * The ancestor crumbs convey position without navigating (`kind: "action"` with no `onSelect`),
 * matching the prototype's non-navigating anchors. This page is mounted beneath **two** different
 * route trees — `/cc`, `/cc/as/:asAccount/:asUser` (ControlCenterRoutes) and the ddc-ui root
 * (InternalUserRoutes) — so no single absolute href is correct for both, and a relative target
 * inside this subtree is exactly research R-010's react-router v7 splat trap. FR-003 asks the trail
 * to convey the page's place, which this does.
 */
export const PageHeading = () => {
  const breadcrumbItems: BreadcrumbItems = [
    {
      label: Locale.getText("CONTROLCENTER") as string,
      configuration: { kind: "action" }
    },
    {
      label: Locale.getText("CONFIGURATION") as string,
      configuration: { kind: "action" }
    }
  ];

  return (
    <Box sx={{ marginBottom: SPACE_BLOCK }}>
      <Box sx={{ marginBottom: "8px" }}>
        <Breadcrumb
          currentPage={Locale.getText("MY_INFO") as string}
          data-testid={"myinfo-breadcrumb"}
          items={breadcrumbItems}
        />
      </Box>

      <Typography variant={"h1"}>
        {Locale.getText("MANAGE_YOUR_USER_INFORMATION") as string}
      </Typography>
    </Box>
  );
};
